module.exports = __webpack_public_path__ + "img/thantaibanso-no.9f2c03c3.png";